<template>
    <ui-modal small>
        <template #header>
            <h3 class="mb-0 text-center" v-text="'Zmiana sposobu płatności'" />
        </template>

        <h6
            v-text="'Wybrany sposób płatności wpłynie na kwestię dodania / usunięcia karty z Twojego konta'"
            class="mb-3 text-sm"
        />

        <check-list
            type="radio"
            size="small"
            class="mt-2"
            :list="$options.paymentTypes"
            :select-row="selectPaymentType"
            :selected-rows="[{ id: selectedPaymentType, value: true }]"
        />

        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                :disabled="isLoader"
                @click="!isLoader && $emit('close-modal')"
            />
            <the-btn
                text="Zapisz"
                class="btn-secondary"
                :disabled="initialPaymentType === selectedPaymentType"
                :loading-status="isLoader ? 'loading' : 'idle'"
                :icon="isLoader ? 'Spinner' : ''"
                @click="saveChanges"
            />
        </template>
    </ui-modal>
</template>

<script>
import { PAYMENT_TYPES } from '@/utils/constants/drs/payment'
import { mapGetters, mapActions } from 'vuex'

export default {
    paymentTypes: PAYMENT_TYPES,

    data: () => ({
        isLoader: false,
        initialPaymentType: null,
        selectedPaymentType: null
    }),

    computed: {
        ...mapGetters('payment', ['cardInfo'])
    },

    methods: {
        ...mapActions('payment', ['updatePaymentInfo']),

        selectPaymentType(paymentType) {
            this.selectedPaymentType = paymentType.id
        },

        async saveChanges() {
            if (this.isLoader || this.initialPaymentType === this.selectedPaymentType) {
                // Early exit to avoid multiple submissions
                return
            }

            this.isLoader = true

            await this.updatePaymentInfo({
                payment_type: this.selectedPaymentType
            })

            this.isLoader = false

            this.$emit('close-modal')
        }
    },

    created() {
        const paymentType = this.cardInfo
            ? PAYMENT_TYPES.find(type => type.value === 'automatic').id
            : PAYMENT_TYPES.find(type => type.value === 'manual').id

        this.initialPaymentType = paymentType
        this.selectedPaymentType = paymentType
    }
}
</script>